import BidEstimateIconRed from "@/assets/images/Tab/bid-estimate-icon-red.png";
import Card from "@/components/Common/Card";

export default function PendingEstimate() {
  return (
    <Card icon={BidEstimateIconRed} title="산출내역서">
      <div className="w-full h-full flex flex-col items-center justify-center">
        <div className="flex flex-col w-full h-full items-center justify-center gap-5 py-14">
          <div className="px-6 py-4 bg-gray-D rounded-full shadow-md">
            <div className="flex gap-1.5 text-2xl text-gray-B font-bold">
              산출내역서
              <span className="text-dark-red">생성 중</span>
            </div>
          </div>
          <p className="text-lg text-gray-B font-semibold">
            산출내역서 생성이 완료되면 메일로 알려드려요
          </p>
        </div>
      </div>
    </Card>
  );
}
